@if (isChatbot) {
  <p-avatar styleClass="custom-avatar" shape="circle" class="chatbot">
    <svg-icon key="chatbot" size="lg"></svg-icon>
  </p-avatar>
} @else if (avatar) {
  <p-avatar styleClass="custom-avatar" shape="circle">
    <img appBlobImage [imageUrl]="avatar" alt="Avatar" class="avatar-img" />
  </p-avatar>
} @else {
  <p-avatar
    styleClass="custom-avatar"
    shape="circle"
    avatarSize="extra-small-secondary"
    [appRandomAvatar]="displayName | nameToCharacters"
    [label]="displayName | nameToCharacters" />
}
